import React from 'react';

import TelegramIcon from '@material-ui/icons/Telegram';
import FacebookIcon from '@material-ui/icons/Facebook';
import YouTubeIcon from '@material-ui/icons/YouTube';
import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';

class ValContacts extends React.Component {
  render() {
    if (!this.props.contacts) return "";

    let contacts = this.props.contacts.split(",");
    return (
      <span>
        {contacts.map((value, index) => {
          return this.getLink(value)
        })}
      </span>
    )

  }

  getLink(val) {
    let value = val.toLowerCase();
    if (value.indexOf("telegram") != -1 || value.indexOf("t.me") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank"><TelegramIcon /></a></span>)
    } else if (value.indexOf("twitter") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank"><TwitterIcon /></a></span>)
    } else if (value.indexOf("facebook") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank"><FacebookIcon /></a></span>)
    } else if (value.indexOf("youtube") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank"><YouTubeIcon /></a></span>)
    } else if (value.indexOf("github") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank"><GitHubIcon /></a></span>)
    } else if (value.indexOf("medium") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank">Medium</a></span>)
    } else if (value.indexOf("discord") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank">Discord</a></span>)
    } else if (value.indexOf("instagram") != -1) {
      return (<span>&nbsp;<a href={value} target="_blank"><InstagramIcon /></a></span>)
    }

    return <span>&nbsp;<a href={value} target="_blank">{value}</a></span>;
  }
}

export default ValContacts;



// WEBPACK FOOTER //
// ./src/base/ValContacts.js